<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewSettings.prices_types.title') }}
      <v-btn
          color="success"
          class="ml-1 green-shadow"
          x-small
          fab
          max-width="26"
          max-height="26"
          :title="$t('common.add')"
          :to="{ name: 'settings-prices-types-create'}"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>
    </h3>
    <v-data-table
        :headers="pricesTypesTableHeader"
        :items="pricesTypes"
        elevation="0"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.coefficient }}%
          </td>
          <td class="text-xs-left">
            <v-checkbox
                v-model="props.item.is_default"
                disabled
                :value="1"
            ></v-checkbox>
          </td>
          <td class="text-xs-left">
            <v-checkbox
                v-model="props.item.for_suppliers_price_with_margin"
                disabled
                value="1"
            ></v-checkbox>
          </td>
          <td class="text-right text-no-wrap">
            <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="primary"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.edit')"
                :to="{ name: 'settings-prices-types-edit', params: { id: props.item.id }}"
            >
              <v-icon small>$pencil</v-icon>
            </v-btn>
            <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="red lighten-2"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.remove')"
                @click="$store.dispatch('prices_types/remove', {id: props.item.id})"
            >
              <v-icon small>$trash</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import router from "../../router";

export default {
  name: "PricesTypesComponent",
  data: () => ({}),
  created() {
    this.onLoad();
  },
  computed: {
    ...mapFields('prices_types', ['pricesTypes']),
    pricesTypesTableHeader() {
      return [
        {text: this.$t('common.title'), value: 'name', sortable: true},
        {text: '%', value: 'coefficient', sortable: true},
        {
          text: this.$t('viewSettings.prices_types.is_default_level'),
          value: 'for_suppliers_price_with_margin',
          sortable: true
        },
        {
          text: this.$t('viewSettings.prices_types.for_suppliers_price_with_margin'),
          value: 'for_suppliers_price_with_margin',
          sortable: true
        },
        {text: this.$t('common.actions'), sortable: false, align:"right"},
      ];
    }

  },
  watch: {
    '$route'(to, from) {
      this.onLoad();
    }
  },
  methods: {
    onLoad() {
      this.$store.dispatch('prices_types/get')
    },
  }
}
</script>

<style scoped>

</style>